import { APIClient } from "@velzon/utils/axios/api_helper.js";

const AxiosClient = new APIClient()
const orderList = (query) => AxiosClient.get(`/order/shopify-list${query}`)
const orderDetails = (query) => AxiosClient.get(`/order/shopify-details${query}`)
const exportOrders = (format) =>
  AxiosClient.get(
    '/order/shopify-list-export',
    { format },
    {
      responseType: 'blob',
      headers: {
        Accept: 'text/csv, application/pdf'
      },
      useParamsSerializer: true
    }
  );
const exportOrderDetails = (format, orderId) =>
  AxiosClient.get(
    '/order/shopify-details-export',
    { format, orderId },
    {
      responseType: 'blob',
      headers: {
        Accept: 'application/pdf'
      },
      useParamsSerializer: true
    }
  );

export {
  orderList,
  orderDetails,
  exportOrders,
  exportOrderDetails
}